import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { AppSettings } from '../enums/app-settings.enum';
import { AddonModel } from '../models/addon-model';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root',
})
export class AddonService {
  private POSTPAID_RESPONSE?: AddonModel;
  private PREPAID_RESPONSE?: AddonModel;
  private VISITOR_LINE_RESPONSE?: AddonModel;
  private CONTROL_LINE_RESPONSE?: AddonModel;
  private E_LIFE_RESPONSE?: AddonModel;
  private TV_RESPONSE?: AddonModel;
  private CALLS_RESPONSE?: AddonModel;

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient, private UTS: UtilitiesService) {}

  public getPostpaid(): Observable<any> {
    if (this.POSTPAID_RESPONSE)
      return this.convertObjectInObservable(this.POSTPAID_RESPONSE);
    return this.getProductsByCategory(AppSettings.POSTPAID);
  }

  public getPrepaid(): Observable<any> {
    if (this.PREPAID_RESPONSE)
      return this.convertObjectInObservable(this.PREPAID_RESPONSE);
    return this.getProductsByCategory(AppSettings.PREPAID);
  }

  public getVisitorLine(): Observable<any> {
    if (this.VISITOR_LINE_RESPONSE)
      return this.convertObjectInObservable(this.VISITOR_LINE_RESPONSE);
    return this.getProductsByCategory(AppSettings.VISITOR_LINE);
  }

  public getControlLine(): Observable<any> {
    if (this.CONTROL_LINE_RESPONSE)
      return this.convertObjectInObservable(this.CONTROL_LINE_RESPONSE);
    return this.getProductsByCategory(AppSettings.CONTROL_LINE);
  }

  public getELife(): Observable<any> {
    if (this.E_LIFE_RESPONSE)
      return this.convertObjectInObservable(this.E_LIFE_RESPONSE);
    return this.getProductsByCategory(AppSettings.E_LIFE);
  }

  public getTV(): Observable<any> {
    if (this.TV_RESPONSE)
      return this.convertObjectInObservable(this.TV_RESPONSE);
    return this.getProductsByCategory(AppSettings.TV);
  }
  public getCalls(): Observable<any> {
    if (this.CALLS_RESPONSE)
      return this.convertObjectInObservable(this.CALLS_RESPONSE);
    return this.getProductsByCategory(AppSettings.CALLS);
  }
  private convertObjectInObservable(D: AddonModel): Observable<any> {
    const OBS = new Observable<any>((O) => {
      O.next(D);
      O.complete();
    });
    return OBS;
  }

  private getProductsByCategory(categoryId: string = ''): Observable<any> {
    const L: string = this.UTS.getLocaleLanguage();
    const iADF: number = AppSettings.IS_APPLY_DEFAULT_FILTERS;
    const C: string = categoryId;
    const NS: string = AppSettings.NAVIGATION_STATE;
    const N: string = AppSettings.NO;
    const payload = { categoryId: C, navigationState: NS, No: N, type: "Addon" };
    return this.http
      .post(
        `${
          environment.BASE_URL
        }/getProductsByCategory?locale=${L}&isApplyDefaultFilters=${
          iADF == 1 ? true : false
        }`,
        payload,
        this.httpOptions
      )
      // .pipe(
      //   map((R: any) => {
      //     if (C === AppSettings.POSTPAID) this.POSTPAID_RESPONSE = R;
      //     if (C === AppSettings.PREPAID) this.PREPAID_RESPONSE = R;
      //     if (C === AppSettings.VISITOR_LINE) this.VISITOR_LINE_RESPONSE = R;
      //     if (C === AppSettings.CONTROL_LINE) this.CONTROL_LINE_RESPONSE = R;
      //     if (C === AppSettings.E_LIFE) this.E_LIFE_RESPONSE = R;
      //     if (C === AppSettings.TV) this.TV_RESPONSE = R;
      //     if (C === AppSettings.CALLS) this.CALLS_RESPONSE = R;
      //     return R;
      //   })
      // );
  }

  bannerImage(cat:string){
    return this.http
      .get(
        `${
          environment.BASE_URL
        }/getBccTexts/buyandget.${cat}.cms.herobanner/`,
        this.httpOptions
      )
  }
  getTabs(cat:string){
    // https://qacms-uat.etisalat.ae/b2c/eshop/getBccTexts/buyandget.cat550027.cms.tabs
    return this.http
      .get(
        `${
          environment.BASE_URL
        }/getBccTexts/buyandget.${cat}.cms.tabs/`,
        this.httpOptions
      )
  }
}
